export default __webpack_public_path__ + "static/media/logo_cazco.d569e43e.svg";